import { newToolFilterOAuthMcp } from "../oauth.ts";

export const audioscrapeMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.audioscrape.com/favicon.ico",
  url: "https://mcp.audioscrape.com",
  label: "Audioscrape",
});
